import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { authGuard } from '@/app/guards/auth.guard';
import { globalAdminGuard } from '@/app/guards/global-admin.guard';
import { unsavedChangesGuard } from '@/app/guards/unsaved-changes.guard';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/_demo/documentation/documentation';
import { Landing } from './app/pages/_demo/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';
import { GameTemplates } from '@/app/pages/game-templates/game-templates';
import { Website } from '@/app/pages/website/website';
import { AddSiteWizard } from '@/app/pages/website/add-site-wizard/add-site-wizard';
import { Companies } from '@/app/pages/companies/companies';
import { Categories } from '@/app/pages/categories/categories';
import { SiteTemplates } from '@/app/pages/site-templates/site-templates';
import { Users } from '@/app/pages/users/users';
import { FakeAuthors } from '@/app/pages/fake-reviews/authors/fake-authors';
import { FakeComments } from '@/app/pages/fake-reviews/comments/fake-comments';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            { path: '', component: Dashboard },
            {
                path: 'uikit',
                loadChildren: () =>
                    import('./app/pages/_demo/uikit/uikit.routes'),
            },
            { path: 'documentation', component: Documentation },
            { path: 'game-templates', component: GameTemplates },
            { path: 'website', component: Website },
            {
                path: 'website/new',
                component: AddSiteWizard,
                canActivate: [globalAdminGuard],
                canDeactivate: [unsavedChangesGuard],
            },
            {
                path: 'website/:realmId',
                component: Website,
                canDeactivate: [unsavedChangesGuard],
            },
            {
                path: 'companies',
                component: Companies,
                canActivate: [globalAdminGuard],
            },
            {
                path: 'categories',
                component: Categories,
                canActivate: [globalAdminGuard],
            },
            {
                path: 'site-templates',
                component: SiteTemplates,
                canActivate: [globalAdminGuard],
            },
            {
                path: 'reviews/fake-authors',
                component: FakeAuthors,
                canActivate: [globalAdminGuard],
            },
            {
                path: 'reviews/fake-comments',
                component: FakeComments,
                canActivate: [globalAdminGuard],
            },
            { path: 'users', component: Users },
            {
                path: 'pages',
                loadChildren: () => import('./app/pages/_demo/pages.routes'),
            },
        ],
    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    {
        path: 'auth',
        loadChildren: () => import('./app/pages/auth/auth.routes'),
    },
    { path: '**', redirectTo: '/notfound' },
];
